import script from "./pc.vue?vue&type=script&setup=true&lang=js"
export * from "./pc.vue?vue&type=script&setup=true&lang=js"

import "./pc.vue?vue&type=style&index=0&id=486b4ade&lang=scss"

const __exports__ = script;

export default __exports__